module.exports = __webpack_public_path__ + "static/media/back.1ba236ca.png";